import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { GTMEventLogger } from 'utils/analytics';

import { MenuConfigWithModule } from 'types/route';

import { GTMEvents } from 'constants/enums';

import styles from './DesktopMenu.module.scss';

interface DesktopMenuProps {
  menuItems: MenuConfigWithModule[];
  onItemClick: () => void;
}

const DesktopMenu: FC<DesktopMenuProps> = ({ menuItems, onItemClick }) => {
  const { t } = useTranslation();

  const handleClick = (event?: GTMEvents) => {
    if (event) {
      GTMEventLogger(event);
    }
    onItemClick();
  };

  return (
    <div className={styles.menuContainer}>
      {menuItems.map((item) => (
        <Link
          to={item.path || '/'}
          key={item.key}
          className={styles.menuItem}
          onClick={() => handleClick(item.event)}
        >
          {item.icon}
          {t(item.label)}
          <span className={styles.description}>{t(item.description)}</span>
        </Link>
      ))}
    </div>
  );
};

export default DesktopMenu;
